<div class="app-wrapper">

    <div class="card-row">
        <div class="card-col">
            <tnr-list></tnr-list>
        </div>
        <div class="card-col">
          <pnr-list></pnr-list>
        </div>
    </div>


</div>
